<template>
  <div
    class="mobile_header"
    @mouseenter="(e)=>{edit_show(e,true)}"
    @mouseleave="(e)=>{edit_show(e,false)}"
    :style="{
      backgroundColor: h_b.radio_val !== 'hidden' ? h_b[h_b.radio_val].color : '',
      backgroundImage:h_b.radio_val !== 'hidden' && h_b[h_b.radio_val].img !== '' ? 'url('+h_b[h_b.radio_val].img+')' : 'none',
      backgroundSize: h_b.radio_val !== 'hidden' ? h_b[h_b.radio_val].background_size: 'auto',
      backgroundRepeat: h_b.radio_val !== 'hidden' ? h_b[h_b.radio_val].background_repeat: 'repeat',
      backgroundPosition: h_b.radio_val !== 'hidden' ? h_b[h_b.radio_val].background_position : '0% 0%',
    }"
  >
    <div
      class="menuPart"
      :class="{ activeIcon: activeIcon }"
      :style="{
        left: $store.state.myRender.common.mb_header_nav_position == 'left' ? '20px' : 'auto',
        right: $store.state.myRender.common.mb_header_nav_position == 'left' ? 'auto' : '20px',
      }"
      v-if="$store.state.myRender.common.setting.headerNavRadio"
    >
      <div class="menuList" @click="activeIcon = !activeIcon">
        <div class="lineTop lineDiv" :style="{
          backgroundColor: h_btn_b.radio_val !== 'hidden' ? (h_btn_b.radio_val === 'custom' ? h_btn_b[h_btn_b.radio_val].color : theme_color) : '',
        }"></div>
        <div class="lineMiddle lineDiv" :style="{
          backgroundColor: h_btn_b.radio_val !== 'hidden' ? (h_btn_b.radio_val === 'custom' ? h_btn_b[h_btn_b.radio_val].color : theme_color) : '',
        }"></div>
        <div class="lineButtom lineDiv" :style="{
          backgroundColor: h_btn_b.radio_val !== 'hidden' ? (h_btn_b.radio_val === 'custom' ? h_btn_b[h_btn_b.radio_val].color : theme_color) : '',
        }"></div>
      </div>
    </div>
    <div class="titlePart">
      <div v-if="useNavLogo" class="nav-logo-wrapper">
        <img :src="navLogo" class="img-nav-logo" alt="logo">
      </div>
      <basic_webtitle v-else-if="$store.state.myRender.common.setting.logoTitleRadio" :module="titleData" :is-in-mobile="true"></basic_webtitle>
    </div>
    <div class="navPart" :class="{ active: activeIcon }">
      <div class="navContent" v-if="$store.state.myRender.common.setting.headerNavRadio">
        <basic_navbar :is-in-mobile-header="true" :module="navData"></basic_navbar>
      </div>
    </div>
    <template v-if="!isPC && $store.state.myRender.common.setting.headerSearchOpen">
      <div :id="`u${search_widgets_id}`" class="searchPart" :class="{ has_language: hasLanguage }">
        <basic_searchs :module="searchModuleData" :source="`mobile_header`" :iconColor="h_btn_b.radio_val === 'custom' ? h_btn_b[h_btn_b.radio_val].color : ''"></basic_searchs>
      </div>
    </template>
   
    <template
      v-if="hasLanguage">
      <basic_language :module="langsData" :iconColor="h_btn_b.radio_val === 'custom' ? h_btn_b[h_btn_b.radio_val].color : ''"></basic_language>
    </template>
    <template v-if="$store.state.myRender.common.setting.zhLanguageOpen && $store.state.app.language == 'zh-cn'">     
      <basic_zhlanguage :module="zhLangData"></basic_zhlanguage>
    </template>
    <!-- 手机端显示 头部登录注册组件 -->
    <template v-if="$store.state.myRender.common.setting.loginRegister">
      <basic_loginregister :module="loginRegisterData" :is-in-mobile-header="true"></basic_loginregister>
    </template>
  </div>
</template>

<script>
import i18n from '../../language/index'

import basic_navbar from "../basic_navbar/index";
import basic_webtitle from "../basic_webtitle/index";
import basic_language from "../basic_language/index";
import basic_searchs from '@/widgets/basic_searchs/index';
import basicSearchsStyle from "@/widgets/basic_searchs/style.js"

export default {
  name: "mobile_header",
  data() {
    return {
      titleData: {},
      activeIcon: false,
      navData: {},
      zhLangData: {},
      searchModuleData: {},
      langsData: {
        rowType: ''
      },
      loginRegisterData: {},
      basicWebTitleVisible: true,
      search_widgets_id: ''
    };
  },
  components: {
    basic_navbar,
    basic_webtitle,
    basic_searchs,
    basic_language
  },
  methods: {
    changeModuleData() {
      let headerData = this.$store.state.myRender.header;      
      let titleData = {};
      let navData = {};
      let langsData = {};
      let zhLangData = {}
      headerData.map(it => {
        if (it.children) {
          it.children.map(item => {
            if (item.children) {
              item.children.map(e => {
                console.log('e.name123', e.name);
                
                if (e.name == "basic_webtitle") {
                  titleData = e;
                }
                if (e.name == "basic_navbar") {
                  navData = e;
                }
                if (e.name == "basic_language") {
                  langsData = e;
                }
                if (e.name == "basic_zhlanguage") {
                  zhLangData = e;
                }
                
              });
            }
          });
        }
      });
      this.titleData = titleData;
      this.navData = navData;
      this.langsData = langsData;
      this.zhLangData = zhLangData;
      
    },
    edit_show(e, val) {
      if (val) {
        //门牌显示出来,此处传参要创建一个类似row的对象，保证数据统一性
        this.templet.mb_edit_show(e, {
          row: {
            name: "mobile_header",
            data: {
              mb_header_background: this.$store.state.myRender.common
                .mb_header_background,
              mb_header_btn_background: this.$store.state.myRender.common
                .mb_header_btn_background
            }
          }
        });
      } else {
        //门牌隐藏
        this.templet.mb_edit_hidden();
      }
    },
    getNavBarData() {
      let rows = this.$store.state.myRender.header
      let basicNavBar = null
      rows.forEach(row => {
        row.children.forEach(col => {
          col.children.forEach(module => {
            console.log(module.name)
            if (module.name === 'basic_navbar') {
              basicNavBar = module
            }
          })
        })
      })
      return basicNavBar
    }
  },
  computed: {
    hasLanguage(){
      return this.$store.state.myRender.common.setting.multiLanguageOpen && this.langsData.rowType == 'header' && this.$store.state.app.language !== 'zh-cn'
    },
    h_b() {
      return this.$store.state.myRender.common.mb_header_background;
    },
    h_btn_b() {
      return this.$store.state.myRender.common.mb_header_btn_background;
    },
    useNavLogo() {
      // 新增需求 如果导航选择的是有logo的样式，就显示导航里的logo，如果导航选择的是没有logo的样式，就显示之前的
      let navBar = this.getNavBarData()
      if (navBar && navBar.data.pc_widgets_infor.showLogo === 'true') {
        return true
      } else {
        return false
      }
    },
    navLogo() {
      let navBar = this.getNavBarData()
      if (navBar && navBar.data.pc_widgets_infor.showLogo === 'true') {
        return navBar.data.listArr.logoUrl || '/static/image/logo.jpg'
      }
    },
    isPC() {
      return this.$store.state.app.view_pattern === 'pc'
    },
    theme_color() {
      return this.$store.state.myRender.common.theme_color;
    },
  },
  created() {
    this.changeModuleData();
    // 头部登录注册
    let basic_loginregister = this.templet.use_name_find_module("header", 'basic_loginregister');
    basic_loginregister && (this.loginRegisterData = basic_loginregister)       
    
    // 添加搜索按钮
    this.$store.commit('app/ADD_widgets_id')
    this.search_widgets_id = this.$store.state.app.widgets_id
    const searchModule = basicSearchsStyle
    searchModule.pc_widgets_infor.styleType = "type_6"
    this.searchModuleData = {
      data: searchModule,
      widgets_id: this.$store.state.app.widgets_id,
    }
  },
  mounted() {
    console.log(this.navData);

  }
};
</script>

<style lang="scss" scoped>
.mobile_header {
  position: relative;
  background-color: #fff;
  height: 50px;
}

.titlePart {
  width: 70%;
  margin: 0 auto;
  position: relative;
}

.pc_pattern .mobile_header .navPart{
  top: 72px;
}
.mobile_header .searchPart{
    width: 50px;
    position: absolute;
    right: 10px;
    height: 100%;
    z-index: 2000;
    top: 0;
    &.has_language{      
      right: 50px;
    }
  .result_rearch_icon{
    font-size: 26px;
    color: #A5A5A5;    
  }
}

.menuPart {
  width: 20px;
  height: 18px;
  position: absolute;
  left: 20px;
  top: 27px;
  transform: translate(0, -50%);
  z-index: 1999;

  .menuList {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .lineDiv {
    width: 20px;
    height: 2px;
    background-color: #333;
    position: absolute;
    transition: 0.36s ease;
  }

  .lineButtom {
    bottom: 0px;
  }

  .lineTop {
    top: 0;
  }

  .lineMiddle {
    top: 8px;
  }
}

.menuPart.activeIcon {
  .lineButtom {
    bottom: 7px;
    transform: rotate(-45deg);
  }

  .lineTop {
    top: 9px;
    transform: rotate(45deg);
  }

  .lineMiddle {
    opacity: 0;
  }
}

.navPart {
  background-color: #fff;
  width: 100%;
  height: 0;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1998;
  padding: 0 16px;
  transition: 0.36s ease;
  overflow: hidden;
}

.navPart.active {
  height: 667px;
}

.navContent {
  margin-top: 50px;
  overflow-x: hidden;
  overflow-y: auto;
  height: 617px;
}

.navContent::-webkit-scrollbar-track {
  -webkit-border-radius: 6px;
  border-radius: 6px;
  background-color: #f1f1f1;
}

.navContent::-webkit-scrollbar {
  width: 0;
}

.navContent::-webkit-scrollbar-thumb {
  -webkit-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);
  background-color: #b1b1b1;
}

.nav-logo-wrapper {
  height: 50px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;

  .img-nav-logo {
    height: 40px;
    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/mobile_header/index.vue